export const filterTasksByCalendar = (tasks, dates, dateKey) => {
    const [startDate, endDate] = dates;
    const filtered = tasks.filter((task) => {
      const taskDate = new Date(task[dateKey]);
      return taskDate >= new Date(startDate) && taskDate <= new Date(endDate);
    });
  
    return filtered.reduce((acc, task) => {
      const taskDate = new Date(task[dateKey]).toISOString().split("T")[0];
      if (!acc[taskDate]) acc[taskDate] = [];
      acc[taskDate].push(task);
      return acc;
    }, {});
  };
  